"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateLocalizationProvider = exports.DateLocalizationContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _reactI18next = require("react-i18next");

var _invariant = _interopRequireDefault(require("invariant"));

var _utils = require("./utils");

var _constants = require("./constants");

var DateLocalizationContext = _react.default.createContext({
  lang: _constants.DEFAULT_LANGUAGE,
  dateLocale: _enUS.default
});

exports.DateLocalizationContext = DateLocalizationContext;

var DateLocalizationProvider = function DateLocalizationProvider(_ref) {
  var children = _ref.children;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      i18n = _useTranslation.i18n;

  var _React$useState = _react.default.useState(i18n.language || _constants.DEFAULT_LANGUAGE),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      lang = _React$useState2[0],
      setLang = _React$useState2[1];

  var _React$useState3 = _react.default.useState(_enUS.default),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      dateLocale = _React$useState4[0],
      setDateLocale = _React$useState4[1];

  _react.default.useEffect(function () {
    // We need this because of race conditions between i18next' init and DateLocalization useEffect
    // see https://itnext.io/the-possible-delay-pitfall-between-reacts-usestate-and-useeffect-383ef1e053d9
    setLang(i18n.language || _constants.DEFAULT_LANGUAGE);
    i18n.on('languageChanged', setLang);
    return function () {
      return i18n.off('languageChanged', setLang);
    };
  }, [i18n, setLang]);

  _react.default.useEffect(function () {
    // we need this because of race conditions happen due to async function
    var shouldSkipUpdate = false;

    var updateDateLocale = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(locale) {
        var newDateLocale;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _invariant.default)(_constants.LANGUAGE_TO_DATE_LOCALE_MAP[locale], "Date locale ".concat(locale, " is not supported"));
                _context.next = 3;
                return _constants.LANGUAGE_TO_DATE_LOCALE_MAP[locale]();

              case 3:
                newDateLocale = _context.sent;

                if (!shouldSkipUpdate) {
                  setDateLocale(newDateLocale);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function updateDateLocale(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    updateDateLocale((0, _utils.getLanguageKey)(lang));
    return function () {
      shouldSkipUpdate = true;
    };
  }, [lang]);

  return /*#__PURE__*/_react.default.createElement(DateLocalizationContext.Provider, {
    value: {
      lang: lang,
      dateLocale: dateLocale
    }
  }, children);
};

exports.DateLocalizationProvider = DateLocalizationProvider;